<template >
  <el-dialog
    title="批量设置寒暑假"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <div id="left">
      <el-form :model="dataForm" :rules="dataRules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
               label-width="80px">
        <el-form-item label="年度" prop="year" >
          <el-date-picker @change="changeYear" type="year" placeholder="选择年度" v-model="dataForm.year" value-format="yyyy" ></el-date-picker>
        </el-form-item>

        <el-form-item label="暑假时间" prop="summerTime">
          <el-date-picker
                  v-model="dataForm.summerTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="寒假时间" prop="winterTime">
          <el-date-picker
                  v-model="dataForm.winterTime"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="岗点" prop="gdid" >
          <el-select clearable   filterable multiple     v-model="dataForm.gdid" placeholder="选择岗点" >
            <el-option
                    v-for="item in gdxxs"
                    :key="item.gdid"
                    :disabled="item.setHoliday===1"
                    :label="item.gdmc"
                    :value="item.gdid">
            </el-option>
          </el-select>

        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {

      const checkAge = (rule, value, callback) => {
        if(value) {
          if ( !/^\d+$/.test(value)) {
            callback(new Error('请输入数字值'));
          } else {
            callback();
          }
        } else callback();
      }
      return {
        visible: false,
        deptdisable:false,
        gdxxs:[],
        dataForm: {
          gdid:[],
          winterTime: [],
          summerTime: [],
          year:this.$moment(new Date()).format('YYYY')

        },
        dataRules: {
          year: [{
            required: true,
            message: '请选择年度',
            trigger: ['blur']
          }],
          summerTime: [{
            required: true,
            message: '请选择暑假时间',
            trigger: ['blur']
          }],
          winterTime: [{
            required: true,
            message: '请选择寒假时间',
            trigger: ['blur']
          }],
          gdid: [{
            required: true,
            message: '请选择岗点id',
            trigger: ['blur']
          }]
        },
      }
    },
    created () {

    },
    methods: {
      typeChange(val) {

      },
      init () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          this.getGdxxs()

        })
      },
      changeYear() {
        this.gdxxs = []
        this.dataForm.gdid = []
        if (this.dataForm.year) {
          this.getGdxxs()
        }
      },
      getGdxxs() {
        this.$request.get(`/bjba/hxgd/swholidays/findGdByYear/${this.dataForm.year}`).then(res => {
          this.gdxxs = res.data.data

        })
      },
      // 表单提交
      dataFormSubmit () {

        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            const data = this.dataForm
            data.bcxx = this.bcxxForm
            this.$http({
              url: '/bjba/hxgd/swholidays/batchSetHoliday',
              method: 'post',
              data: {year:this.dataForm.year,summerBeginTime:this.dataForm.summerTime[0],summerEndTime:this.dataForm.summerTime[1],
              winterBeginTime:this.dataForm.winterTime[0],winterEndTime:this.dataForm.winterTime[1],gdids:this.dataForm.gdid}
            }
            ).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              }else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: "error",
                  duration: 1500
                })
              }
            })
          }
        })
      },


    }
  }
</script>

<style lang="scss" scoped>

</style>
